import React, { useState, useRef,useEffect } from "react";
import ImmediateSessionDot from "../ImmediateSessionDot";
import moment from "moment";
import Search from "../../../../components/search";
import { filterList } from "../data";
import { useSelector } from "react-redux";
import Sorting from "../../../../components/sorting";
import Select from "react-select";
import Pagination from "../../../../components/tablePagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fireFilter } from "../functions";
import CsvDownload from "../../../../components/csvdownload";
import Button from "../../../../components/button";
import { setLoading, setLoadingContent, setLoadingText } from "../../../../reducer/auth/auth";
import { session_id_beg, session_id_end } from "../../../../utils/helpers";
import AppointmentInfoPanel from "../AppointmentInfoPanel";
import Filter from "../../../../components/filter";
import UpdateAppointments from "../../Subcomponents/updateappt";
import { toast } from "react-toastify";
import { showRefundNotice } from "../../../../utils/refundNotice";
import CopyComponent from "../../../../components/copyComponent";
import {ExportData} from "../../../../services/admin";
import { useDispatch } from "react-redux";
import { emptyAllSelectBox, filterVisibleTimeZones } from "../../../../utils/helpers";
import { refundingAppointment, stopPaymentAppointment } from "../../../../services/medium";

var apptAvatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function apptGetInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function apptGetAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % apptAvatarPalettes.length : 0;
  return Object.assign({}, apptAvatarPalettes[idx], {
    width: 36, height: 36, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '13px', flexShrink: 0,
  });
}

const headers = [
  { label: "Medium Name", key: "medium_name" },
  { label: "Client Name", key: "client_name" },
  { label: "Date", key: "date" },
  { label: "Time", key: "time" },
  { label: "Session Name", key: "session_type" },
  // { label: "Emails", key: "emails" },
  // { label: "Meeting Link", key: "meeting_link" },
  // { label: 'Feedback Links', key: "" },
  // { label: 'Date and Time Cancelled', key: 'date_time_canceled' },
  { label: "Cancelled By", key: "userby" },
  // { label: "No Show By", key: 'userby' },
];
export default function Cancelled(props) {
  const {
    canceledAppointment,
    filterListAppointments,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    cancelledAppointmentsPage,
    cancelledAppointmentsrowsPerPage,
    searchValue,
    filterValues,
    serviceTypeList,
    changeHandlerFilter,
    serviceFilterValue,
    setSortingNameOrderBy,
    setSortingTabType,
    filterReset,
    getAllAppointmentsList,
    exportDownload,
    activeTab,
    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    setServiceTypeShow,
    serviceTypeShow,
    searchValueFilter,
    onTransferCount,
    setAllCancelledCount,
    setCanceledAppointments,
    isSearching

  } = props;
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  const { allCancelledCount } = useSelector((state) => state.users);
  const [updateItem, setUpdateItem] = useState({});
    const dispatch = useDispatch()
    const [filters, setFilters] = useState({ filterValues: { screen_name: ""}, operator: "" });
      const filtersRef = useRef({ filterValues: {}, operator: "" });
      const [isFilterDirty, setIsFilterDirty] = useState(true);
      const [panelAppointment, setPanelAppointment] = useState(null);
      const [panelViewType, setPanelViewType] = useState('appointment');

  // };
  const navigate = useNavigate();
   useEffect(() => {
       
        if (filterOprater && Object.keys(searchValue).length > 0) {
        const newValues = {
          filterValues: { ...searchValue },
          operator: filterOprater
        };
  
      console.log("NEW VALUES:", newValues);
        filtersRef.current = newValues; 
      }
    
      }, [])
  const openUpdateappointmentBox = (item) => {
    setUpdateItem(item)
    window.loadModal2('#UpdateAppointments', 'show')
  }
  
  const getAppointmentsNewList = () => {

    const info = {
      page: cancelledAppointmentsPage,
      rowsPerPage: cancelledAppointmentsrowsPerPage,
    };
    getAllAppointmentsList(info, activeTab)
    window.loadModal2('#UpdateAppointments', 'hide')
  }
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const navigateEdit = (e, id) => {
     window.renderFirst = false
     console.log(e.target.className);
    if (e.target.className == "capitalize_medium") {
       navigate(`/profile-edit/${id.medium_id}?&searchURL=appointments&view=2&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
    } 
    if(e.target.className == "capitalize_client"){
      if(id.client_user_type == 3){
        navigate(`/edit/${id.client_id}?&searchURL=appointments&view=2&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }else{
        navigate(`/profile-edit/${id.client_id}?&searchURL=appointments&view=2&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }
    }  
  };
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id
    }
    else if (appoinment.is_group_session === 1) {
      if (appoinment.attendees == undefined) {
        if (appoinment.parent_id == null) {
          return appoinment.id
        }
        else {
          return appoinment.parent_id
        }

      }
      else {
        return appoinment.id
      }

    }
    else {
      return appoinment.id
    }

  }

  const handleSessionClick = (e, appoinment, columnType = 'appointment') => {
    if (e.target.closest && e.target.closest('button, a, input, select, textarea, [role="button"], .toggle-button-cover')) {
      return;
    }
    e.stopPropagation();
    if (columnType === 'medium' && !appoinment.medium_details) {
      columnType = 'appointment';
    }
    if (columnType === 'client' && !appoinment.client_details) {
      columnType = 'appointment';
    }
    setPanelViewType(columnType);
    setPanelAppointment(Object.assign({}, appoinment, {
      sessionIdDisplay: session_id_beg + checkAppId(appoinment) + session_id_end,
    }));
  };

  const createString =() => {

    let string = `screen_name=${
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : ""}&session_type=${searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : ""}&session_id=${searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : ""}&name=${
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : ""}&medium_email=${
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : ""}&client_email=${
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : ""}&meeting_id=${
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          :""}&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ''}&oprater=${filterOprater !== undefined ? filterOprater : ""}&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}
      `
      return string;
  }
  const exportData =()=>{
       let info = {
              appoitment_type: "cancelled", appoitment_value: 3,queryString: createString()
          }
      ExportData(info).then((data) => {
              if (data.data.status) {
                  toast.success(data.data.message, { position: "top-center" });
              }
              }).catch(() => { })
    }

    const exportAllData = () => {
      let info = {
        appoitment_type: "cancelled", 
        appoitment_value: 3,
        queryString: "" 
      }
      ExportData(info).then((data) => {
        if (data.data.status) {
          toast.success("All data exported successfully", { position: "top-center" });
        }
      }).catch(() => { })
    }

     const getAppointmentsNewListData = (toName, id ) => {
    console.log(`Updated: moved one from to ${toName}`);
    window.loadModal2('#UpdateAppointments', 'hide')
    setCanceledAppointments((prev) => prev.filter((item) => item.id !== id));
    dispatch(
            setAllCancelledCount(
              allCancelledCount - 1
              )
          )
    onTransferCount( "Cancelled", toName);
    
  
    // you can call API or refresh appointment list here
  };
   const fliterdata = (name, oprater) => {
  const newValues = {
    filterValues: { ...name },
    operator: oprater
  };
console.log("NEW VALUES:", newValues);
  filtersRef.current = newValues; // <--- instant update (no delay)
  setFilters(newValues);
  setIsFilterDirty(false);          // UI update (async, but that's fine)
};


const LoadData = () => {
  // optional: clear old UI result before new search
  console.log("FILTERS USED:", filtersRef.current.filterValues, filtersRef.current.operator);


// setUpcomingAppointments([]);
  filterListAppointments(
    filtersRef.current.filterValues,
    filtersRef.current.operator
  );
  setIsFilterDirty(true);
};
const handleNoShow = (e, appoinment) => {
  let value = e.target.value;
    let noShowBy = value;
    if(value === "refund"){
      refundingCall(appoinment.medium_id, appoinment.id);
      return;
    }
     if(value === "stop_payment_request"){
      stopPaymentCall(appoinment.medium_id, appoinment.id);
      return;
    }
}
 const refundingCall = (mediumId, appointmentId) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId
    }
   
      refundingAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))
          setCanceledAppointments(prev =>
          prev.map(item =>
            item.id === appointmentId
              ? { ...item, payment_status: "Refunding" }
              : item
          )
        );


          setTimeout(() => {
            showRefundNotice(data);
          }, 1000);


        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
      });
  }

  const stopPaymentCall = (mediumId, appointmentId) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId
    }
   
      stopPaymentAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

setCanceledAppointments(prev =>
          prev.map(item =>
            item.id === appointmentId
              ? { ...item, payment_status: "Waived" }
              : item
          )
        );
          setTimeout(() => {
          
              //no show
              toast.success("Status Updated Successfully", {
                position: "top-center",
              });
            
            
          }, 1000);

          
        }
        else {

      // ✅ THIS will show "Transaction not found"
      toast.error(data.data.message || "Something went wrong", {
        position: "top-center",
      });

    }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
      //    toast.error("Something went wrong", {
      //   position: "top-center",
      // });
      });
  }
  return (
    <>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th className="min-width-100">Session #</th>
              <th>
                {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
                Medium Name
              </th>
              <th>Client Name</th>
              <th>
                <div className="d-flex align-items-center">
                  <span>Date &amp; Time</span>
                  <Sorting tab={3} callApi={filterListAppointments} view={'admin'} types={'date'} setSortingNameOrderBy={setSortingNameOrderBy} setSortingTabType={setSortingTabType} />
                </div>
              </th>
              <th>Session Name</th>
              {/* <th>Meeting Link</th> */}
              <th>Date &amp; Time<br />Cancelled</th>
              <th>Cancelled By</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Payment<br />Status</th>
              <th>Payment<br />Issue</th>
              <th><div className="d-inline-flex align-items-center align-items-center">
                <span> Created at</span>{" "}
                <Sorting tab={3} callApi={filterListAppointments} view={'admin'} types={'created_at'} setSortingNameOrderBy={setSortingNameOrderBy}
                  setSortingTabType={setSortingTabType} />
              </div></th>
              {/* <th>Action</th> */}
            </tr>
            {isSearching ? (
              <tr>
    <td colSpan="12" className="text-center py-4">
      <div className="custom-loader">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
      </div>
      <div className="loader-text mt-2">Loading appointments...</div>
    </td>
  </tr>
                ) :
            canceledAppointment.length > 0 ? (
              canceledAppointment.map((appoinment) => (
                <tr onClick={(e) => handleSessionClick(e, appoinment)} className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" }`} style={{ cursor: 'pointer' }}>
                  {/* <td>{session_id_beg + checkAppId(appoinment) + session_id_end}{appoinment.is_replaced === 1 ? <img className="ml-1 star-app-hightlight" src="../images/blackstar.jpeg" /> : ''}</td> */}
                  <td className="pointer" onClick={(e) => handleSessionClick(e, appoinment)}>
                    <div className="d-flex align-items-center">
                      <ImmediateSessionDot appointment={appoinment} /><div className="mr-1 mt-1"><CopyComponent value={session_id_beg + checkAppId(appoinment) + session_id_end} /></div>
                      <div className="mt-1">{session_id_beg + checkAppId(appoinment) + session_id_end}</div>{appoinment.is_replaced === 1 ? <img className="ml-1 star-app-hightlight" src="../images/blackstar.jpeg" /> : ''}
                      <div className="mr-1 mt-1 ml-1">
                        {appoinment.backfill_code !== null ? <>
                          ({appoinment.backfill_code})
                        </> : <></>
                        }
                      </div>
                      </div>
                      
                      </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }}>
                    {/* <input type="checkbox" id="two" />
                    <label htmlFor="two"></label> */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {appoinment.medium_profile_image ? (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                            <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.medium_profile_image} alt="" />
                          </div>
                        ) : (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_medium' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.medium_name)}>{apptGetInitials(appoinment.medium_name)}</div>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span className="capitalize_medium" style={{ display: 'block' }}>{appoinment.medium_name} {appoinment.medium_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                          <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {appoinment.medium_email} <CopyComponent value={appoinment.medium_email} />
                          </div>
                        </div>
                      </div>
                    </div>

                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {appoinment.client_profile_image ? (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                          <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                        </div>
                      ) : (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize_client' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                      )}
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span className="capitalize_client" style={{ display: 'block' }}>{appoinment.client_name} {appoinment.client_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                        <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                        </div>
                      </div>
                    </div>
                    
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td className="width-190px ">{appoinment.guest_booking == 1 ? (<b style={{
                          fontSize: '22px',
                        }}>*</b>) : ""}{appoinment.session_name}</td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.modifiedDate ? appoinment.modifiedDate.split(',')[0] : ''}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.modifiedDate && appoinment.modifiedDate.split(',')[1] ? appoinment.modifiedDate.split(',')[1].trim() : ''}</div>
                  </td>
                  <td>{appoinment.userby}</td>
                  <td>{appoinment.reason}</td>
                  <td>

                    <Button
                      status={0}
                      onClick={(e) => openUpdateappointmentBox(appoinment)}
                      type="button"
                      className={`resend-btn w-130`}
                      title="Change Status"
                    />

                  </td>
                  <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 ?

                      <div className={`${appoinment.payment_status != null ? "color-d5a67b" : ""} d-flex align-items-center height-45`}>
                        {appoinment.payment_status != null && appoinment.payment_status != "NULL" ? (appoinment.payment_status) : 'N/A'}
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined ?
                      <>
                        {appoinment.is_group_session === 0 && (appoinment.session_type == "7" || appoinment.session_type == "8") ?
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>
                              {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding") && (
                              <>
                              
                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )}
                            {/* {(appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" )&& (
                              <option
                                value={
                                  appoinment.payment_status === "Paid"
                                    ? "refund"
                                    : "stop_payment_request"
                                }
                              >
                                {appoinment.payment_status === "Paid"
                                  ? "Refunding"
                                  : "Stop Payment Request"}
                              </option>
                            )} */}


                            
                         
                          </select>
                          :
                          'N/A'
                        }
                      </>
                      :

                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.createdDate ? (
                      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                        <span>{appoinment.createdDate.split(',')[0]}</span>
                        <span style={{ color: '#888', fontSize: '12px' }}>{(appoinment.createdDate.split(',')[1] || '').trim()}</span>
                      </div>
                    ) : ''}
                  </td>
                  {/* <td>
                    <div>
                      <p className="d-flex">
                        <div> Client:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.client_email}{" "}
                        </div>
                      </p>
                      <p className="d-flex">
                        {" "}
                        <div>Medium:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.medium_email}
                        </div>
                      </p>
                    </div>
                  </td> */}
                  {/* <td>Practice - 60 Min (30 Min each)</td> */}
                  {/* <td className="googl-link">
                    <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      alt="copy"
                      src="images/copy.png"
                    />
                  </td> */}
                  {/* <td className="change">
                    <a href="#">
                      <img src="../images/email-blu.png" />
                      Email
                    </a>
                  </td> */}
                  {/* <td className="dot-image">
                    <img src="../images/Unionblck.png" />
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
            {/* <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr> */}
          </tbody>
        </table>
        </div>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allCancelledCount}
          activeTab={"cancelledAdmin"}
          getPaginationData={getPaginationData}
          cancelledAppointmentsPage={cancelledAppointmentsPage}
          cancelledAppointmentsrowsPerPage={cancelledAppointmentsrowsPerPage}
        />
        <UpdateAppointments
          updateItem={updateItem}
          appType={['Complete', 'No Show', 'Restrict', 'Ended Early']}
          from="cancel"
          getAppointmentsNewList={getAppointmentsNewListData}
        />
        <AppointmentInfoPanel
          appointment={panelAppointment}
          viewType={panelViewType}
          onClose={() => setPanelAppointment(null)}
          onMediumClick={(appt) => navigateEdit({ target: { className: 'capitalize_medium' } }, appt)}
          onClientClick={(appt) => navigateEdit({ target: { className: 'capitalize_client' } }, appt)}
        />
      </div>
    </>
  );
}
